/**
 * Calidad de código: el regreso del detalle de un proyecto al tablero. El
 * tablero guarda sus filtros en la URL (filtro, q y gate) y, al abrir un
 * proyecto, pasa esa URL en el state de la navegación; «Regresar» del
 * detalle vuelve a ella. Funciones puras, sin
 * Angular, compartidas por el tablero y el detalle.
 */

/** La ruta del tablero: la entrada del módulo y el destino de «Regresar». */
export const RUTA_TABLERO = "/admin/calidad-codigo/tablero";

/** Lo que el tablero deja en el state de la navegación al abrir un proyecto. */
export interface EstadoRegresoCc {
  /** La URL del tablero tal como estaba, con sus filtros (router.url). */
  volverA: string;
}

/** El state con que el tablero abre el detalle de un proyecto. */
export function estadoDeRegreso(urlTablero: string): EstadoRegresoCc {
  return { volverA: urlTablero };
}

/**
 * A dónde regresa el detalle: la URL que dejó el tablero, solo si es del
 * propio tablero (su ruta, sola o con su consulta) y se puede leer. Con
 * cualquier otra cosa (sin state porque se llegó por un enlace directo o
 * desde otra pantalla, la URL de otra pantalla o de fuera, un %XX roto que
 * el router no entendería), el tablero sin filtros.
 */
export function destinoDeRegreso(estado: unknown): string {
  const url = (estado as Partial<EstadoRegresoCc> | null | undefined)?.volverA;
  if (typeof url !== "string") {
    return RUTA_TABLERO;
  }
  const delTablero = url === RUTA_TABLERO || url.startsWith(`${RUTA_TABLERO}?`);
  return delTablero && legible(url) ? url : RUTA_TABLERO;
}

/** La URL se puede decodificar entera: el router la leería sin caer en la raíz de la aplicación. */
function legible(url: string): boolean {
  try {
    decodeURIComponent(url);
    return true;
  } catch {
    return false;
  }
}
